/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Stack, Typography } from "@mui/material";
import { X } from "@phosphor-icons/react";

import { styles } from "./styles";
import { FootballPartnerCardProps } from "./types";
import { sanitizeText } from "@/utils/string";

const FOOTBALL_URL = "https://www.abasteceai-futebol.com.br/";

/**
 * Get club logo or defaul shield if logo not exists
 */
const getClubLogo = (logo: string, defaultShield?: string) => {
  if ((!logo || logo.includes("logo_visitante")) && defaultShield) {
    return defaultShield;
  }

  return logo;
};

export const FootballPartnerCard: React.FC<FootballPartnerCardProps> = ({
  clubLogo,
  club,
  valueWithoutPoints,
  valueWithPoints,
  clubOpponent,
  matchDate,
  clubOpponentLogo,
  description,
  points,
  matchTime,
  stadium,
  stadiumSector,
  defaultShield
}) => {
  const [sector, sectorGate] = stadiumSector.split("-");

  const onClick = () => {
    try {
      const sanitizedTitle = sanitizeText(description);

      if ((window as any).dataLayer) {
        (window as any).dataLayer.push({
          event: "hero_interaction",
          content_type: `${sanitizedTitle}:ir-para-o-site`
        });
        console.log("Evento de interação enviado para o Google Tag Manager:", sanitizedTitle);
      }
    } catch (error) {
      console.error("Erro ao enviar o evento de interação para o Google Tag Manager", error);
    }
  };

  return (
    <Card css={styles.footballcard}>
      <Stack css={styles.footballcard__stack}>
        <CardActionArea
          onClick={() => {
            window.open(FOOTBALL_URL, "_blank");
          }}
          css={styles.footballcard__button}
        >
          <CardContent css={styles.footballcard__content} sx={{ padding: 0 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-evenly" sx={{ backgroundColor: "#e5f6fd", height: "195px" }}>
              <CardMedia image={getClubLogo(clubLogo, defaultShield)} title={`Escudo do ${club}`} css={styles.footballcard__image} />

              <X size={32} css={styles.footballcard__x} />

              <CardMedia image={getClubLogo(clubOpponentLogo, defaultShield)} title={`Escudo do ${clubOpponent}`} css={styles.footballcard__image} />
            </Stack>
            <Stack css={styles.footballcard_infos}>
              <Typography variant="subtitle2" css={styles.footballcard__datetime}>
                {matchDate} às {matchTime}
              </Typography>

              <Typography variant="h6" css={styles.footballcard__title}>
                {description}
              </Typography>
              <Stack sx={{ minHeight: "67.17px" }}>
                <Typography variant="body2" css={styles.footballcard__stadium} sx={{ fontWeight: "bold" }}>
                  {stadium}
                </Typography>

                <Typography variant="body2" css={styles.footballcard__sector}>
                  {sector} {sectorGate ? "-" : ""}
                  <br />
                  {sectorGate}
                </Typography>
              </Stack>
            </Stack>

            <Stack sx={{ padding: "16px" }}>
              <Box css={styles.divider} />
              <Typography variant="body2" css={styles.footballcard__oldprice}>
                De {valueWithoutPoints}
              </Typography>

              <Typography variant="body2" css={styles.footballcard__newprice}>
                Por {valueWithPoints}
                <Typography component="span" css={styles.footballcard__kms}>
                  {" + "}
                  {points} pontos KMV
                </Typography>
              </Typography>
              <Button
                css={styles.footballcard__clickbutton}
                variant="contained"
                sx={{ fontSize: 12, fontWeight: "bold" }}
                href={FOOTBALL_URL}
                target="_blank"
                onClick={onClick}
              >
                IR PARA O SITE
              </Button>
            </Stack>
          </CardContent>
        </CardActionArea>
      </Stack>
    </Card>
  );
};
